import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { WalletQrCodeResolveDto } from "@/features/wallet/api/dto";

/**
 * Lit le QR d'un tiers (`GET /WalletQrCodes/resolve/{token}`) avant
 * paiement. Jeton forgé / périmé : même forme de réponse (pas d'énumération).
 */
export const useResolveWalletQr = (token: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_QR_RESOLVE(token),
    queryFn: () =>
      fetchDataGet<WalletQrCodeResolveDto>({
        url: walletEndpoints.walletQrCodes.resolve(token),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && token.trim().length > 0,
  });
